import React from "react";
import { Mail, MessageCircle, MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function Contact({ settings }) {
  const wa = (settings?.whatsapp_number || "+31614908691").replace(/[^0-9]/g, "");
  return (
    <section id="contact" className="relative overflow-hidden bg-gradient-to-b from-[#120726] to-sfc-night px-5 py-28 lg:px-10">
      <div className="mx-auto max-w-5xl">
        <Reveal>
          <div className="rounded-[2.5rem] border border-white/10 bg-white/[0.03] p-10 lg:p-14">
            <span className="text-xs font-semibold uppercase tracking-[0.3em] text-sfc-cyan">Contact</span>
            <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-white sm:text-5xl">
              Laten we samen iets moois schenken
            </h2>
            <p className="mt-4 max-w-xl text-white/65">
              Vragen over ons assortiment, samenwerking of levering? Ons salesteam denkt graag met u mee.
            </p>
            <div className="mt-10 grid gap-5 sm:grid-cols-3">
              <a data-testid="contact-email" href={`mailto:${settings?.sales_email || "sales@soulfoodcity.nl"}`} className="rounded-2xl border border-white/10 p-5 transition-colors hover:border-sfc-orange/50">
                <Mail className="text-sfc-orange" size={24} />
                <p className="mt-3 text-sm font-medium text-white">E-mail</p>
                <p className="text-xs text-white/55">{settings?.sales_email || "sales@soulfoodcity.nl"}</p>
              </a>
              <a data-testid="contact-whatsapp" href={`https://wa.me/${wa}`} target="_blank" rel="noopener noreferrer" className="rounded-2xl border border-white/10 p-5 transition-colors hover:border-sfc-orange/50">
                <MessageCircle className="text-[#25D366]" size={24} />
                <p className="mt-3 text-sm font-medium text-white">WhatsApp</p>
                <p className="text-xs text-white/55">{settings?.whatsapp_number || "+31614908691"}</p>
              </a>
              <div className="rounded-2xl border border-white/10 p-5">
                <MapPin className="text-sfc-cyan" size={24} />
                <p className="mt-3 text-sm font-medium text-white">Levering</p>
                <p className="text-xs text-white/55">Landelijk, heel Nederland</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
